<script>
import WhyWeFirst from "@js/components/Sections/InfoCards/WhyWeFirst.vue";
import HowToBuy from "@js/components/Sections/HowToBuy/HowToBuy.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import CompanyGuarantees from "@js/components/Sections/InfoCards/CompanyGuarantees.vue";
import FeedbackPlatforms from "@js/components/Sections/Feedbacks/FeedbackPlatforms.vue";
import Feedbacks from "@js/components/Sections/Feedbacks/Feedbacks.vue";
import CallbackBigForm from "@js/components/Sections/Callback/CallbackBigForm.vue";
import HomeFaq from "@js/components/Sections/Faqs/HomeFaq.vue";
import {useThemeStore} from "@js/store/ThemeStore.js";
import ServicesTopComponent from "@js/components/Sections/TopComponents/ServicesTopComponent.vue";
import CompanyServices from "@js/components/Sections/Services/CompanyServices.vue";
import CallbackRoundedDarkForm from "@js/components/Sections/Callback/CallbackRoundedDarkForm.vue";

export default {
    name: "ServicesPage",
    components: {
        CallbackRoundedDarkForm,
        CompanyServices,
        ServicesTopComponent,
        HomeFaq,
        CallbackBigForm,
        Feedbacks,
        FeedbackPlatforms,
        CompanyGuarantees,
        OnlyDesktop,
        HowToBuy,
        WhyWeFirst
    },
    beforeMount() {
        this.themeStore.activateLightTheme()
    },
    setup() {
        const themeStore = useThemeStore()

        return {themeStore}
    }
}
</script>

<template>
    <ServicesTopComponent/>
    <CompanyServices/>
    <OnlyDesktop>
        <CompanyGuarantees/>
    </OnlyDesktop>
    <HowToBuy/>
    <CallbackRoundedDarkForm/>
    <WhyWeFirst/>
    <FeedbackPlatforms/>
    <Feedbacks class="pt-20"/>
    <CallbackBigForm/>
    <HomeFaq/>
</template>

<style scoped lang="scss">

</style>
